import { render, staticRenderFns } from "./AffiliatePerformance.vue?vue&type=template&id=7df8bf36&"
import script from "./AffiliatePerformance.vue?vue&type=script&lang=js&"
export * from "./AffiliatePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports